import {
    CLEAR_CREDENTIALS, CLEAR_INVITATION_DATA, EMPTY_AUTH,
    FETCH_LOGGED_IN_USER, FETCH_LOGGED_IN_USER_SUCCESS, FETCH_LOGGED_IN_USER_FAILURE,
    FETCH_LOGIN, FETCH_LOGIN_SUCCESS, FETCH_LOGIN_FAILURE,
    FETCH_REQUEST_INVITATION, FETCH_REQUEST_INVITATION_SUCCESS, FETCH_REQUEST_INVITATION_FAILURE,
    FETCH_RESET_PASSWORD, FETCH_RESET_PASSWORD_SUCCESS, FETCH_RESET_PASSWORD_FAILURE,
    FETCH_SIGNUP, FETCH_SIGNUP_SUCCESS, FETCH_SIGNUP_FAILURE,
    SEND_FORGOT_PASSWORD_EMAIL, SEND_FORGOT_PASSWORD_EMAIL_SUCCESS, SEND_FORGOT_PASSWORD_EMAIL_FAILURE,
    SET_CREDENTIALS, SET_INVITATION_DATA, SET_TOKEN, SET_USER, UPDATE_AUTH
} from './constants';

import clone from 'clone';

import { setError } from 'containers/Errors/store/actions';
import Request from 'utils/request';
import { PATHS } from 'utils/paths';
import { LOCALSTORAGE } from 'utils/constants';

export const clearCredentials = () => ({
    type: CLEAR_CREDENTIALS
});

export const clearInvitationData = () => ({
    type: CLEAR_INVITATION_DATA
});

export const emptyAuth = () => ({
    type: EMPTY_AUTH
});

const fetchLoggedInUser = (showSpinner) => ({
    type: FETCH_LOGGED_IN_USER,
    showSpinner
});

const fetchLoggedInUserSuccess = (data) => ({
    type: FETCH_LOGGED_IN_USER_SUCCESS,
    data
});

const fetchLoggedInUserFailure = (error) => ({
    type: FETCH_LOGGED_IN_USER_FAILURE,
    error
});

const fetchLogin = () => ({
    type: FETCH_LOGIN
});

const fetchLoginSuccess = (data) => ({
    type: FETCH_LOGIN_SUCCESS,
    data
});

const fetchLoginFailure = (error) => ({
    type: FETCH_LOGIN_FAILURE,
    error
});

const fetchRequestInvitation = () => ({
    type: FETCH_REQUEST_INVITATION
});

const fetchRequestInvitationSuccess = () => ({
    type: FETCH_REQUEST_INVITATION_SUCCESS
});

const fetchRequestInvitationFailure = (error) => ({
    type: FETCH_REQUEST_INVITATION_FAILURE,
    error
});

const fetchResetPassword = () => ({
    type: FETCH_RESET_PASSWORD
});

const fetchResetPasswordFailure = (error) => ({
    type: FETCH_RESET_PASSWORD_FAILURE,
    error
});

const fetchResetPasswordSuccess = (data) => ({
    type: FETCH_RESET_PASSWORD_SUCCESS,
    data
});

export const fetchSignup = () => ({
    type: FETCH_SIGNUP
});

export const fetchSignupSuccess = (data) => ({
    type: FETCH_SIGNUP_SUCCESS,
    data
});

export const fetchSignupFailure = (error) => ({
    type: FETCH_SIGNUP_FAILURE,
    error
});

const sendForgotPasswordEmail = () => ({
    type: SEND_FORGOT_PASSWORD_EMAIL
});

const sendForgotPasswordEmailSuccess = () => ({
    type: SEND_FORGOT_PASSWORD_EMAIL_SUCCESS
});

const sendForgotPasswordEmailFailure = (error) => ({
    type: SEND_FORGOT_PASSWORD_EMAIL_FAILURE,
    error
});

export const setCredentials = (data) => ({
    type: SET_CREDENTIALS,
    data
});

export const setInvitationData = (data) => ({
    type: SET_INVITATION_DATA,
    data
});

export const setToken = (data) => ({
    type: SET_TOKEN,
    data
});

export const setAuthUser = (data) => ({
    type: SET_USER,
    data
});

export const updateAuth = (data) => ({
    type: UPDATE_AUTH,
    data
});



/**
 *  ASYNC ACTIONS
 */

export const getLoggedInUser = (token, showSpinner) => (dispatch, getStore) => {
    dispatch(fetchLoggedInUser(showSpinner));


    if(token == null) {
        token = getStore().auth.token;
    }

    console.log(token);

    let request = new Request(token);

    return request.get(PATHS.user.getLoggedIn())
        .then((response) => {
            dispatch(fetchLoggedInUserSuccess(response.data.data));
            return response;
        })
        .catch((error) => {
            console.log('getLoggedInUser error', error, error.response);
            if(error.response.status === 401) {
                error.friendlyMessage = 'Your session is expired. Please login and try again.';
                dispatch(setError(401, error.friendlyMessage));
            } else {
                error.friendlyMessage = 'There was an error getting your user information. Please try again.';
            }
            dispatch(fetchLoggedInUserFailure(error));
            throw error;
        });
};

export const login = () => (dispatch, getStore) => {
    dispatch(fetchLogin());

    let credentials = clone(getStore().auth.credentials);

    let request = new Request(getStore().auth.token);

    return request.post(PATHS.auth.login(), credentials)
        .then((response) => {
            console.log(response.data.data);
            localStorage.setItem(LOCALSTORAGE.ID_TOKEN, response.data.data.token);

            dispatch(setToken(response.data.data.token));
            dispatch(fetchLoginSuccess(response.data.data.user));
            return response;
        })
        .catch((error) => {
            console.log('login error', error, error.response);
            if(error.response.status === 401) {
                error.friendlyMessage = 'Incorrect username or password. Please try again.';
            } else {
                error.friendlyMessage = 'There was an error logging in. Please try again.';
            }
            dispatch(fetchLoginFailure(error));
            throw error;
        });
};

export const postForgotPassword = () => (dispatch, getStore) => {
    dispatch(sendForgotPasswordEmail());

    let request = new Request(getStore().auth.token);

    return request.post(PATHS.auth.forgotPassword(), {email: getStore().auth.credentials.email})
        .then((response) => {
            dispatch(sendForgotPasswordEmailSuccess());
            return response;
        })
        .catch((error) => {
            console.log('postForgotPassword error', error, error.response);
            error.friendlyMessage = 'There was an error sending your password reset email. Please try again.';
            dispatch(sendForgotPasswordEmailFailure(error));
            throw error;
        });
};

export const postRecommendation = () => (dispatch, getStore) => {
    dispatch(fetchRequestInvitation());

    let request = new Request(getStore().auth.token);

    return request.post(PATHS.app.sendRecommendation(), getStore().auth.invitationData)
        .then((response) => {
            dispatch(fetchRequestInvitationSuccess());
            return response;
        })
        .catch((error) => {
            console.log('postRecommendation error', error, error.response);
            error.friendlyMessage = 'There was an error sending your request. Please try again.';
            dispatch(fetchRequestInvitationFailure(error));
            return error;
        });
};

export const postRequestInvitation = () => (dispatch, getStore) => {
    dispatch(fetchRequestInvitation());

    let request = new Request();

    return request.post(PATHS.auth.sendRequestInvitation(), getStore().auth.invitationData)
        .then((response) => {
            dispatch(fetchRequestInvitationSuccess());
            return response;
        })
        .catch((error) => {
            console.log('postRequestInvitation error', error, error.response);
            error.friendlyMessage = 'There was an error sending your request. Please try again.';
            dispatch(fetchRequestInvitationFailure(error));
            throw error;
        });
};

export const postResetPassword = (token) => (dispatch, getStore) => {
    dispatch(fetchResetPassword());

    let body = {
        password: getStore().auth.credentials.password,
        token
    };

    let request = new Request(getStore().auth.token);

    return request.post(PATHS.auth.resetPassword(), body)
        .then((response) => {
            let credentials = clone(getStore().auth.credentials);
            credentials.password = '';
            delete credentials.passwordConfirm;
            dispatch(fetchResetPasswordSuccess(credentials));
            return response;
        })
        .catch((error) => {
            console.log('postResetPassword error', error, error.response);
            error.friendlyMessage = 'There was an error with this reset request. Please try again.';
            dispatch(fetchResetPasswordFailure(error));
            throw error;
        });
};

export const signup = (stripeSource, promoCode) => (dispatch, getStore) => {
    dispatch(fetchSignup());

    let user = clone(getStore().accounts.user);
    let company = clone(getStore().accounts.company);

    let body = {
        company,
        user,
        plan: company.subscriptionTier,
        stripeSource
    };

    if(promoCode) {
        body.promoCode = promoCode;
    }

    let request = new Request(getStore().auth.token);

    return request.post(PATHS.company.create(), body)
        .then((response) => {
            localStorage.setItem(LOCALSTORAGE.ID_TOKEN, response.data.data.token);
            dispatch(setToken(response.data.data.token));
            dispatch(fetchSignupSuccess(response.data.data.user));
            return response;
        })
        .catch((error) => {
            console.log('signup error', error, error.response);
            if(error.response.status === 400) {
                error.friendlyMessage = `There was an error signing up. ${error.response && error.response.data ? `"${error.response.data.error}"` : ''}`;
            } else if(error.response.status === 500) {
                error.friendlyMessage = `There was an internal server error, please contact support with this error code: ${error.body ? error.body.breadcrumb : '11'}`;
            } else {
                error.friendlyMessage = 'There was an error saving your profile. ';
            }
            console.log('signup error', error.message);
            dispatch(fetchSignupFailure(error));
            throw error;
        });
};

export const setAuthError = (name, error) => (dispatch, getStore) => {
    let newAuthObj = clone(getStore().auth);

    if(error == null) {
        newAuthObj[name] = {};
    } else {
        newAuthObj[name] = {friendlyMessage: error};
    }

    dispatch(updateAuth(newAuthObj));
};



// WEBPACK FOOTER //
// ./src/containers/Auth/store/actions.js